import { createHead } from '@unhead/vue/client'
import { createApp } from 'vue'

import App from './App.vue'
import i18n from './i18n'
import router from './router'
import rum from './rum'
import { pinia } from './store/pinia'

import './style.css'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(i18n)
app.use(router)
app.use(pinia)

rum.setRouter(router)
if (import.meta.env.PROD) {
  app.config.errorHandler = err => {
    rum.addError(err)
  }
}

app.mount('#app')

export { app }
